/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Matching_Score_Category_Role_FitInputs */

const en_matching_score_category_role_fit = /** @type {(inputs: Matching_Score_Category_Role_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Role fit`)
};

const de_matching_score_category_role_fit = /** @type {(inputs: Matching_Score_Category_Role_FitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollenpassung`)
};

/**
* | output |
* | --- |
* | "Role fit" |
*
* @param {Matching_Score_Category_Role_FitInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const matching_score_category_role_fit = /** @type {((inputs?: Matching_Score_Category_Role_FitInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Matching_Score_Category_Role_FitInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_matching_score_category_role_fit(inputs)
	return en_matching_score_category_role_fit(inputs)
});